export function isIOSMobile() {
	return /iPhone|iPod/.test(navigator.userAgent);
}

export function isIOS() {
	return (
		isIOSMobile() ||
		/iPad/.test(navigator.userAgent) ||
		// iPad on iOS 13 detection
		(navigator.userAgent.includes('Mac') && 'ontouchend' in document)
	);
}

export function isIOSSafari() {
	return isIOS() && !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
}

export function isIOSNotChrome() {
	return isIOS() && !/CriOS/.test(navigator.userAgent);
}
